import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Renderiza markdown do chat com wrap/scroll seguros pra containers estreitos
 * (ex.: o chat flutuante de ~420px). Sem isso, tabelas e linhas longas
 * estouravam a largura da bolha e cortavam o texto. */
export function renderMarkdown(content: string) {
  return (
    <div className="text-xs leading-relaxed break-words [overflow-wrap:anywhere] [&_p]:my-1 [&_ul]:my-1 [&_ul]:pl-4 [&_ol]:my-1 [&_ol]:pl-4 [&_li]:my-0.5 [&_h1]:text-[13px] [&_h2]:text-[13px] [&_h3]:text-xs [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_h1]:mt-2 [&_h2]:mt-2 [&_h3]:mt-1.5 [&_strong]:font-semibold [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-2 [&_blockquote]:text-muted-foreground">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Tabela rola no eixo X dentro da bolha (não força a largura toda).
          table: (props) => (
            <div className="overflow-x-auto max-w-full my-1.5">
              <table className="border-collapse text-[11px]" {...props} />
            </div>
          ),
          th: (props) => (
            <th
              className="border border-border px-1.5 py-0.5 text-left font-semibold whitespace-nowrap"
              {...props}
            />
          ),
          td: (props) => (
            <td className="border border-border px-1.5 py-0.5 align-top" {...props} />
          ),
          pre: (props) => (
            <pre
              className="overflow-x-auto max-w-full bg-black/5 rounded p-2 my-1.5 text-[11px]"
              {...props}
            />
          ),
          code: (props) => <code className="break-words" {...props} />,
          a: (props) => (
            <a className="underline text-primary break-words" {...props} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
